import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CategoryImagesUtil } from '~app/modules/catalog/utils/category-images.util';
import { Category } from '~app/modules/generic/models';
import { environment } from '~env/environment';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { GATrackingEventType, GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

@Component({
  selector: 'app-sub-category-card',
  templateUrl: './sub-category-card.component.html',
  styleUrls: ['./sub-category-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubCategoryCardComponent {
  @Input() category: Category;
  @Input() parentCategoryName: string;
  @Input() isMobile: boolean;

  readonly CATEGORY_PLACEHOLDER_IMG = 'images/product-catalog-placeholder.png';
  readonly MOBILE_IMAGE_SIZE = 50;
  readonly DESKTOP_AND_TABLET_IMAGE_SIZE = 70;

  market: string;
  defaultCategoryImage = `${environment.cdnBaseUrl()}/${this.CATEGORY_PLACEHOLDER_IMG}`;

  constructor(private gtmDatalayerService: GtmDatalayerService) {
    this.market = getCountryDomainCode();
  }

  onCategoryClick(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_PLP_CATEGORY_NAVIGATION,
      GA_eventname: GaTrackingEventName.GridNavigation,
      action: GaTrackingEventAction.PLP_CATEGORY_NAVIGATION,
      category: this.parentCategoryName,
      label: this.category.name,
    });
  }

  getSource(categoryId: string): string {
    const imageSize = this.isMobile ? this.MOBILE_IMAGE_SIZE : this.DESKTOP_AND_TABLET_IMAGE_SIZE;

    return CategoryImagesUtil.getCategoryImageSrc(categoryId, imageSize, imageSize);
  }

  getSourceSet(categoryId: string): string {
    const imageSize = this.isMobile ? this.MOBILE_IMAGE_SIZE : this.DESKTOP_AND_TABLET_IMAGE_SIZE;

    return CategoryImagesUtil.getCategoryImageSrcSet(categoryId, imageSize, imageSize);
  }
}
